<div class="flex flex-col gap-4">
  <!-- QR a la izquierda + instrucción al lado (antes: QR centrado y solo) -->
  <div
    data-test="mfa-qr-block"
    class="flex flex-col items-stretch gap-3 rounded-lg border border-gray-200 bg-slate-50 p-3.5 sm:flex-row sm:items-center sm:gap-4 dark:border-gray-700 dark:bg-gray-800"
  >
    <!--
      Sin tamaño fijo y sin `overflow-hidden` A PROPÓSITO: la caja mide
      exactamente QR + padding + borde por construcción. Con `box-sizing:
      border-box` (preflight de Tailwind) un cuadrado fijo de 132px deja un área
      de contenido de 114px y el canvas de 132px se recortaba en silencio, sin
      el patrón de posicionamiento inferior izquierdo — un QR ilegible.
      `[margin]="2"` devuelve la zona de silencio, que viaja dentro de la propia
      imagen y sobrevive a cualquier cambio del contenedor.

      Vale IGUAL para los 180px de teléfono: el ancho cambia, la caja lo sigue
      midiendo por contenido. Nada de cuadrados calculados a mano.
    -->
    <div
      data-test="mfa-qr-box"
      class="inline-flex flex-none items-center justify-center self-center rounded-md border border-gray-200 bg-white p-3 sm:self-auto"
    >
      @if (otpauthUri) {
        <qrcode
          [qrdata]="otpauthUri"
          [width]="qrWidth()"
          [errorCorrectionLevel]="'M'"
          [margin]="2"
        ></qrcode>
      }
    </div>
    <!--
      Bajo el QR en teléfono, y SIEMPRE alineado a la izquierda: centrado, un
      párrafo de dos o tres renglones se lee como un cartel y no como una
      instrucción. `min-w-0` deja que el texto se encoja en vez de empujar.
    -->
    <div class="min-w-0 text-left text-pretty">
      <b class="block text-md font-semibold">
        {{ 'mfa_setup_qr_title' | transloco }}
      </b>
      <p class="text-secondary mt-1 text-md leading-5">
        {{ 'mfa_setup_qr_body' | transloco }}
      </p>
    </div>
  </div>

  <!-- Clave manual: disclosure cerrado (escanear es el camino normal) -->
  <div>
    <!--
      El texto primero y el chevron al final (`ml-auto`): con el chevron
      adelante, en 412px el rótulo se parte en dos renglones colgando de un
      icono. Así es una sola corrida de texto que fluye y el indicador queda
      donde el pulgar lo busca.
    -->
    <button
      type="button"
      data-test="mfa-manual-toggle"
      class="text-primary flex w-full items-center gap-2 text-left text-md font-semibold"
      [attr.aria-expanded]="showKey()"
      (click)="toggleKey()"
    >
      <span class="min-w-0 text-pretty">
        {{ 'mfa_setup_manual_hint' | transloco }}
      </span>
      <mat-icon
        class="icon-size-4 ml-auto flex-none text-gray-400"
        [svgIcon]="
          showKey()
            ? 'heroicons_outline:chevron-down'
            : 'heroicons_outline:chevron-right'
        "
      ></mat-icon>
    </button>

    @if (showKey()) {
      <div
        data-test="mfa-manual-key"
        class="mt-2 flex items-center gap-2 rounded-md border border-gray-200 py-1.5 pl-3 pr-2 dark:border-gray-700"
      >
        <span class="min-w-0 flex-1 truncate font-mono text-sm tracking-wider">
          {{ secret }}
        </span>
        @if (canCopy) {
          <button
            type="button"
            data-test="mfa-copy-key"
            class="text-primary flex-none rounded-full bg-slate-100 px-2.5 py-1 text-sm font-semibold dark:bg-gray-700"
            (click)="copyKey()"
          >
            {{
              (keyCopied() ? 'mfa_setup_key_copied' : 'mfa_setup_copy_key')
                | transloco
            }}
          </button>
        }
      </div>
      @if (keyCopyFailed()) {
        <p data-test="mfa-key-copy-error" class="mt-1 text-sm text-red-600">{{ 'mfa_setup_key_copy_error' | transloco }}</p>
      }
    }
  </div>

  <!-- Campo OTP -->
  <div class="flex flex-col gap-2">
    <span class="text-sm font-semibold">
      {{ 'mfa_setup_code_label' | transloco }}
    </span>

    <app-otp-input
      [formControl]="control"
      [length]="6"
      [invalid]="!!errorKey"
      [ariaLabel]="'mfa_setup_code_label' | transloco"
      (completed)="confirmed.emit($event)"
    ></app-otp-input>

    @if (errorKey) {
      <span
        data-test="mfa-code-error"
        class="flex items-center gap-1.5 text-sm font-semibold text-red-600"
      >
        <mat-icon
          class="icon-size-4 text-red-600"
          [svgIcon]="'heroicons_outline:exclamation-circle'"
        ></mat-icon>
        {{ errorKey | transloco }}
      </span>
    } @else {
      <span class="text-secondary flex items-center gap-1.5 text-sm">
        <mat-icon
          class="icon-size-4 text-gray-400"
          [svgIcon]="'heroicons_outline:clock'"
        ></mat-icon>
        {{ 'mfa_setup_code_hint' | transloco }}
      </span>
    }
  </div>
</div>
